const idGenerator = (() => {
  let counter = -1;
  return {
    next: () => {
      return counter--;
    },
    reset: () => {
      counter = -1;
    },
  };
})();

export default idGenerator;
